import { FunctionComponent, useEffect, useState } from 'react'
import DashboardItem from '../DashboardItem'
import { useTranslation } from 'react-i18next'
import WorkroomItem from './WorkroomItem'
import { useManageWorkroomsContext } from './manageWorkroomContext'
import Paging from 'Features/Paging/paging'

const AllWorkrooms: FunctionComponent = () => {
  const { workrooms, getAllWorkrooms } = useManageWorkroomsContext()
  const { t } = useTranslation()
  const [activePage, setActivePage] = useState<number>(workrooms != null ? workrooms?.pageIndex : 1)

  const changePage = (activePage: number) => {
    setActivePage(activePage)

    getAllWorkrooms(activePage)
  }

  if (!workrooms) return <></>

  return (
    <DashboardItem heading={t('all-workrooms')}>
      <div>
        <div className="d-flex justify-content-between fw-bold dashboard__description-label">
          <span>{t('dashboard.workrooms.workroom-name')}:</span>
          <span className="me-4">{t('dashboard.workrooms.owner')}:</span>
        </div>
        <ul className="list-unstyled d-flex flex-column">
          {workrooms && workrooms?.items.length > 0 ? (
            <>
              {workrooms.items.map((workroom) => (
                <WorkroomItem
                  workroom={workroom}
                  key={`hidden-workroom-${workroom.id}`}
                  callback={() => getAllWorkrooms()}
                />
              ))}
            </>
          ) : (
            <span>{t('there-are-no-workrooms')}</span>
          )}
        </ul>
      </div>
      {workrooms.totalPages > 1 && (
        <Paging
          noOfPages={workrooms?.totalPages as number}
          activePage={activePage}
          callback={(activePage) => {
            changePage(activePage)
          }}
        />
      )}
    </DashboardItem>
  )
}

export default AllWorkrooms
